<template>
	<div
		:class="{
			'alert-item': true,
			[theme]: true,
			[alert.type]: true,
			closeable: alert.closeable,
		}"
		:style="{ '--delay': `${alert.delay}ms` }"
	>
		<OutlineCheckmarkIcon v-if="alert.type === 'success'" class="alert-icon" />
		<ExclamationIcon v-if="alert.type === 'error'" class="alert-icon" />
		<div class="alert-text">
			{{ alert.text }}

			<div class="alert-close" v-if="alert.closeable" @click="alert.close()">
				<CloseIcon />
			</div>
		</div>
		<div class="progress" v-if="alert.autoClose" />
	</div>
</template>

<script>
import { OutlineCheckmarkIcon, ExclamationIcon, CloseIcon } from '@/icons'
import { addEscapeListener } from '@/helpers/escape'

export default {
	name: 'AlertItem',
	components: { OutlineCheckmarkIcon, ExclamationIcon, CloseIcon },
	props: ['theme', 'alert'],
	mounted() {
		this.removeListener = addEscapeListener(() => {
			this.$attrs.alert.close()
		})
	},
	beforeUnmount() {
		this.removeListener?.()
	},
}
</script>

<style lang="scss" scoped></style>
